import { render, staticRenderFns } from "./ImportModalNotZone.vue?vue&type=template&id=67976498&scoped=true"
import script from "./ImportModalNotZone.vue?vue&type=script&lang=js"
export * from "./ImportModalNotZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67976498",
  null
  
)

export default component.exports